import { inject, provide, ref } from 'vue'
import { FeedKey } from '@/api/types'
import { IFeedAttributes } from '@/interfaces/feeds'
import { useFeedsStore } from '@/store/modules/feeds'

const useFetchFeed = () => {
  const feedsStore = useFeedsStore()
  const feed = ref<IFeedAttributes | undefined>(undefined)
  const fetchingFeed = ref(false)

  function FetchItem(id: string, skipId?: boolean): void {
    fetchingFeed.value = true
    feedsStore
      .FetchItem(id)
      .then(() => {
        const storedItem = feedsStore.itemById(id)
        if (storedItem !== undefined && storedItem !== null) {
          if (skipId) {
            delete storedItem['id']
            feed.value = { ...storedItem } as IFeedAttributes
          } else {
            feed.value = storedItem as IFeedAttributes
          }
        }
      })
      .finally(() => {
        fetchingFeed.value = false
      })
  }

  const provideFeed = function () {
    provide(FeedKey, feed)
    return feed
  }

  const injectFeed = function () {
    return inject(FeedKey)
  }

  return { feed, fetchingFeed, FetchItem, provideFeed, injectFeed }
}

export default useFetchFeed
